import CreateConversationEntrypointPage from "@faire/prototype-playground/workspace/aw/create-conversation-entrypoint";
import FdInviteAsAutomationPage from "@faire/prototype-playground/workspace/aw/fd-invite-as-automation";
import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

const BrandPortalAutomationsPage = lazy(
  () => import("../../workspace/aw/fd-invite-as-automation/AutomationsPage")
);

export function AbigailWaterstonRoutes() {
  return (
    <Switch>
      <Route
        path="/aw/create-conversation-entrypoint"
        component={CreateConversationEntrypointPage}
      />
      <Route
        path="/aw/fd-invite-as-automation/automations"
        component={BrandPortalAutomationsPage}
      />
      <Route
        path="/aw/fd-invite-as-automation"
        component={FdInviteAsAutomationPage}
      />
    </Switch>
  );
}

export const slug = "aw";
